"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MappedModelBase_1 = require("./MappedModelBase");
/**
 * Widget configuration model.
 *
 * @extendable
 */
class WidgetConfig extends MappedModelBase_1.default {
    constructor() {
        super(...arguments);
        /**
         * The html container id.
         *
         * @type {null}
         */
        this.containerId = null;
        /**
         * Switch for enabling auto scroll in view.
         *
         * Scroll in view is used when steps change and they are no longer
         * in view. This happens when a large height step is changed to a
         * small one.
         *
         * @type {boolean}
         */
        this.autoScrollInView = null;
        /**
         * Whether to scroll in view on first render if scroll in view enabled.
         *
         * @type {boolean}
         */
        this.scrollInViewOnFirstRender = null;
    }
    /**
     * Constructs from configuration object.
     *
     * @param config
     * @return {WidgetConfig}
     */
    static fromObject(config) {
        const instance = new this();
        Object.keys(this.getValueMapping().value).forEach((key) => {
            if (config[key] !== undefined) {
                instance[key] = config[key];
            }
        });
        return instance;
    }
    /**
     * Gets default configuration values.
     *
     * @return {*}
     */
    static getDefaults() {
        return {
            autoScrollInView: true,
            scrollInViewOnFirstRender: false
        };
    }
    /**
     * Gets the ID of the container html element.
     *
     * @return {string}
     */
    getContainerId() {
        return this.containerId;
    }
    /**
     * Determines if auto scroll enabled.
     *
     * @return {boolean}
     */
    isAutoScrollInViewEnabled() {
        return this.autoScrollInView;
    }
    /**
     * Determines if auto scroll should happen on first render.
     *
     * @return {boolean}
     */
    shouldAutoScrollOnFirstRender() {
        return this.scrollInViewOnFirstRender;
    }
    /**
     * Gets container parameters from configuration to the build service container.
     *
     * @return {Object}
     */
    getContainerParameters() {
        return {};
    }
    /**
     * @inheritDoc
     */
    static getValueMapping() {
        return super.getValueMapping({
            containerId: {
                type: "string",
                getter: true,
                required: true,
            },
            autoScrollInView: {
                type: "boolean",
                getter: "isAutoScrollInViewEnabled",
                required: true
            },
            scrollInViewOnFirstRender: {
                type: "boolean",
                getter: "shouldAutoScrollOnFirstRender",
                required: true
            }
        });
    }
}
exports.default = WidgetConfig;
